var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "md-portal",
    [
      _c("transition", { attrs: { name: "md-dialog" } }, [
        _c("nav", { attrs: { title: _vm.title } }, [
          _vm.mdActive
            ? _c(
                "div",
                { staticClass: "md-dialog" },
                [
                  _c("md-focus-trap", [
                    _c(
                      "div",
                      _vm._g(
                        {
                          staticClass: "md-dialog-container",
                          class: [
                            _vm.dialogContainerClasses,
                            _vm.$mdActiveTheme,
                          ],
                          on: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k($event.keyCode, "esc", 27, $event.key, [
                                  "Esc",
                                  "Escape",
                                ])
                              )
                                return null
                              return _vm.onEsc.apply(null, arguments)
                            },
                          },
                        },
                        _vm.$listeners
                      ),
                      [
                        _vm._t("default"),
                        _vm._v(" "),
                        _c(
                          "keep-alive",
                          [
                            _vm.mdBackdrop
                              ? _c("md-overlay", {
                                  class: _vm.mdBackdropClass,
                                  attrs: {
                                    "md-fixed": "",
                                    "md-active": _vm.mdActive,
                                  },
                                  on: { click: _vm.onClick },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }